import logger from '@dp/varyag-hoc-component/logger';
import owl from '@dp/varyag-hoc-component/logger/owl';
import { platformName } from "../config/platformInfo";

import page from '../pages/index';
import { queryStringArgs } from '../lib/util';
import * as environments from '../config/environments';
import environment from '../lib/environment';
import favicon from '../lib/favicon';

favicon();

owl({
    devMode: environment !== environments.PRODUCTION,
    project: platformName,
    pageUrl: `${window.location.origin}/app/${platformName}/html/index.html`,
});

const {
    pageId,
    shopId,
} = queryStringArgs;

if (!pageId || !shopId) {
    logger('pageError').error('URL参数 pageId 或 shopId 缺失');
    window.location.href = 'https://m.dianping.com/notfound';
} else {
    page();
}

if (module.hot) {
    module.hot.accept('../pages/index', () => {
        const newPage = require('../pages/index').default;
        newPage();
    });
}



// WEBPACK FOOTER //
// ./src/entries/index.js